import ChargerInfo from "./ChargerInfo";
import { chargerDetailsMap, fieldGroups } from "./constants";
import PropTypes from "prop-types";
import { LoaderCircle, X } from "lucide-react";

import useChargerConfig from "./hooks/useChargerConfig";
import { useGlobalFilters } from "../../lib/context/GlobalFilterProvider";
import ErrorCard from "../../lib/components/ErrorCard";
import { formatDate } from "../../lib/utils/utility";
import { IconButton } from "@mui/material";
import { TEXT_LIBRARY } from "../../lib/utils/constants";

function ChargerDetails({ onClick }) {
  const { siteId, serialNumber } = useGlobalFilters();
  const { config, loading, error } = useChargerConfig(siteId, serialNumber);

  const dateKeys = new Set(["lastReportedAt", "createdAt", "warrantyDueDate", "warrantyStartDate"]);

  function formatValue(key, value) {
    if (dateKeys.has(key)) return formatDate(value);
    return value ? String(value) : "-";
  }
  function renderDetails(data) {
    if (!data) return <div className="text-gray-500 p-4">No data available</div>;
    return (
      <div className="charger-details-card">
        {fieldGroups.map(group => (
          <div key={group.title} className="details-group">
            <h4 className="text-sm font-semibold text-gray-500 mb-3 uppercase tracking-wider border-b p-5 pl-2">
              {group.title}
            </h4>

            <div className="technical-grid">
              {group.keys.map(key => {
                if (!chargerDetailsMap[key]) return null;

                return <ChargerInfo key={key} label={chargerDetailsMap[key]} value={formatValue(key, data?.[key])} />;
              })}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="charger-info">
      <div className="charger-details-header">
        <span className="charger-details-title">Charger Status and Configuration</span>
        <IconButton size="small" onClick={onClick} sx={{ mt: -0.5, mr: -1, color: "var(--color-text)" }}>
          <X />
        </IconButton>
      </div>
      <div className="charger-details-content">
        {!error && loading && siteId && (
          <div className="flex flex-col items-center justify-center w-full h-full">
            <LoaderCircle className="animate-spin charger-details-loader mb-2" size={38} />
            <span className="charger-details-loader-text text-base font-medium">Loading...</span>
          </div>
        )}
        {error && <ErrorCard errorText={TEXT_LIBRARY.SERVER_ERROR} />}
        {!siteId && <ErrorCard errorText={TEXT_LIBRARY.NO_ACTIVE_SITEID_FOUND} />}
        {!loading && !error && <div className="w-full">{renderDetails(config)}</div>}
      </div>
    </div>
  );
}
ChargerDetails.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ChargerDetails;
